import React, { useEffect } from "react";
import styled from "styled-components";
import usePageRect from "./usePageRect";
import { useAppDispatch } from "../api/core/useAppDispatch";
import usePreviousValue from "../../../../common/ui/usePreviousValue";
import { scrollToStartLocation } from "../api/features/hash-nav/actions";

const Styled = {
  Holder: styled.div`
    position: absolute;
    top: 0;
  `,
  Page: styled.div`
    position: absolute;
    overflow: hidden;
  `,
};

export default function PageAreaHolder({ children, className = "" }) {
  const rect = usePageRect();
  const prevRect = usePreviousValue(rect);
  const dispatch = useAppDispatch();

  /**
   * When the page viewer does its initial positioning, force a rescroll to the
   * start location. The automatic position syncing on resize provided by
   * ScrollSync is not as accurate and the event debounces make the timing
   * difficult to manage.
   */
  useEffect(() => {
    if (prevRect && prevRect.left < 0 && rect.left > 0) {
      dispatch(scrollToStartLocation());
    }
  }, [rect, prevRect, dispatch]);

  function getStyle() {
    return {
      transform: `translate(${rect.left}px,${rect.top}px)`,
      width: `${Math.round(rect.width)}px`,
      height: `${Math.round(rect.height)}px`,
    };
  }

  return (
    <Styled.Holder className={className}>
      <Styled.Page style={getStyle()}>{children}</Styled.Page>
    </Styled.Holder>
  );
}
